module.exports = __webpack_public_path__ + "img/quanmeiti.e67d8b80.png";